import '../css/index.scss'
import $ from 'jquery'
import { setupLenis } from "../scripts/lenis.js";


/**js**/
'use strict';

var windowWidth = $(window).width();
var windowHeight = $(window).height();
const breakPoint = 768;

const setup = () => {

  const lenis = setupLenis();
  const anchors = document.querySelectorAll('.nav-item-link');
  anchors.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      lenis.scrollTo( '#' + this.getAttribute('data-target'))
    });
  })

  // files load

  const _pathname = location.pathname;
  const _dirlang = (_pathname.startsWith('/app/') ? _pathname.slice(5, 8) : _pathname.slice(1, 4)).replace(/\W/g, '');

  // const _wovnlang = document.cookie.split('; ').map(cookie => ({ key: cookie.split('=')[0], value: cookie.split('=')[1]})).find(cookie => cookie.key == 'wovn_selected_lang');
  // console.log(_wovnlang?.value);

  // const isEnglish = _dirlang === 'en' || (_pathname.indexOf("/program/") === 0 || _pathname.indexOf("/history/") === 0) && (_wovnlang?.value === 'en');
  const isEnglish = _dirlang === 'en';
  const prefix = isEnglish ? 'en_' : '';

  $('.js-gnav_ctn').load(`/assets/files/${prefix}gnav.html`);
  $('.js-drawer-cnt').load(`/assets/files/${prefix}drawer_nav.html`);
  $('.js-footer-cnt').load(`/assets/files/${prefix}footer.html`);

};

setup();


/*----------------------------------------------------------
    初期表示設定
----------------------------------------------------------*/

// load
window.addEventListener('load',function(){

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  if (!isMobileDevice()) {
    $('.p-navigation-global').css({'display':'flex'});
  } else {
    $('.p-navigation-global').css({'display':'none'});
  }

  const body = document.querySelector( 'body' );
  setTimeout(() => {
    body.classList.add('opening');
    setTimeout(() => {
      body.classList.add('complete');
      body.classList.remove('opening');
    }, 300);
  }, 300);

  // UA
  const _ua = (function(u){
    return {
      Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
        || u.indexOf("ipad") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
        || u.indexOf("kindle") != -1
        || u.indexOf("silk") != -1
        || u.indexOf("playbook") != -1,
      Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
        || u.indexOf("iphone") != -1
        || u.indexOf("ipod") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
        || u.indexOf("blackberry") != -1
    }
  })(window.navigator.userAgent.toLowerCase());

  if(!_ua.Mobile && !_ua.Tablet){

  } else {

    const winHeight = window.innerHeight;
    const setHeights = document.querySelectorAll(".js-setHeight");

    setHeights.forEach((setHeight) => {
      setHeight.style.setProperty('height', `${winHeight}px`);
    });

  }

});


// resize
let resizeTimer;
const interval = 0;

window.addEventListener('resize', function() {

  if (resizeTimer !== false) {
    clearTimeout(resizeTimer);
  }

  resizeTimer = setTimeout(function() {
    windowHeight = $(window).height();
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }, interval);

});


$(function(){

  // animate
  var current_scrollY;
  current_scrollY = $(window).scrollTop();
  triggerAnimation(current_scrollY);

  $(window).on('scroll', function () {

    current_scrollY = $( window ).scrollTop();
    triggerAnimation(current_scrollY);

  });

  function triggerAnimation(scroll) {
    const scrollBottom = scroll + $(window).height();
    $('.animate').each(function() {
      const top = $(this).offset().top;
      if(scrollBottom > top) {
        $(this).addClass('is-animated');
      } else {
        // $(this).removeClass('is-animated');
      }
    })
  }

  /*----------------------------------------------------------
    drawer-nav
  ----------------------------------------------------------*/

  var gNavi = $('.drawer-nav');
  var gNaviButton = $('.js-drawer-nav');
  var drawerNaviButton = $('.navi-item .navi-item__button');

  gNaviButton.on('click', function(){
    $('body').toggleClass('is-drawer-open');
  });

  // gNaviButton.on('click', function(){
  //   $('body').toggleClass('is-drawer-open');
  // });

});


$(function(){

  var pagetopBtn = $('#pagetop');
  $(window).on('scroll', function(){
    if( $(this).scrollTop() > ( $(window).height() * .25 )){
      pagetopBtn.addClass('is-active');
      $('body').addClass('is-scroll');
    } else {
      pagetopBtn.removeClass('is-active');
      $('body').removeClass('is-scroll');
    }

    if( $(this).scrollTop() > ( $(window).height() * .50 )){
      $('#mainvisual').removeClass('--visible-scene01');
      $('#mainvisual').addClass('--visible-scene02');
    } else {
      $('#mainvisual').addClass('--visible-scene01');
      $('#mainvisual').removeClass('--visible-scene02');
    }

  });

  pagetopBtn.on('click', function(){
    $('body,html').animate({ scrollTop: 0 }, 500);
    return false;
  });

});

/*----------------------------------------------------------
 MegaMenu Control
----------------------------------------------------------*/

const megaMenuButtons = document.querySelectorAll(".js-button-megaMenu");
const openClass = "is-open";

const isTouchDevice = () => {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0 ||
    window.matchMedia("(pointer: coarse)").matches
  );
};

const isMobileDevice = () => {
  return window.matchMedia(`(max-width: ${breakPoint}px)`).matches;
};

const menuToggleAction = (e) => {
  if (!isTouchDevice() && !isMobileDevice()) {
    return;
  }

  const button = e.currentTarget;
  const currentMegaMenu = button.closest(".js-megaMenu");
  const isOpened = currentMegaMenu.classList.contains(openClass);

  document.querySelectorAll(`.js-megaMenu.${openClass}`).forEach((megaMenu) => {
    if (megaMenu !== currentMegaMenu) {
      megaMenu.classList.remove(openClass);
    }
  });

  currentMegaMenu.classList.toggle(openClass, !isOpened);
};

megaMenuButtons.forEach((button) => {
  //button.addEventListener("touchstart", menuToggleAction);
  button.addEventListener("click", menuToggleAction);
});

const resetMegaMenu = () => {
  const megaMenus = document.querySelectorAll(".js-megaMenu");
  megaMenus.forEach((megaMenu) => {
    megaMenu.classList.remove(openClass);
  });
};

let resizeTimerMs;

window.addEventListener("resize", () => {
  const delayMs = 200;
  clearTimeout(resizeTimerMs);
  resizeTimerMs = setTimeout(() => {
    if (
      window.matchMedia(`(min-width: ${breakPoint}px)`).matches
    ) {
      resetMegaMenu();
    }
  }, delayMs);
});
